/**
 * Analytical Tree - Node Table View
 * Simple tabular listing of nodes as an alternate view to the graph.
 */

import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

const getWorstSeverity = (anomalies = []) => {
  if (!anomalies.length) return 'none';
  if (anomalies.some((a) => a.severity === 'critical')) return 'critical';
  if (anomalies.some((a) => a.severity === 'warning')) return 'warning';
  if (anomalies.some((a) => a.severity === 'info')) return 'info';
  return 'unknown';
};

const NodeTable = ({ nodes, onSelectNode }) => {
  const rows = nodes || [];

  return (
    <Paper sx={{ p: 1 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Nodes
      </Typography>
      {rows.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No nodes loaded. Use the controls above and click &quot;Load Tree&quot;.
        </Typography>
      ) : (
        <TableContainer sx={{ maxHeight: 420 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Label</TableCell>
                <TableCell>Type</TableCell>
                <TableCell align="right">Anomalies</TableCell>
                <TableCell>Worst Severity</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((n) => {
                const worst = getWorstSeverity(n.anomalies);
                return (
                  <TableRow
                    key={n.id}
                    hover
                    sx={{ cursor: 'pointer' }}
                    onClick={() => onSelectNode && onSelectNode(n)}
                  >
                    <TableCell>{n.label || n.id}</TableCell>
                    <TableCell>{n.type}</TableCell>
                    <TableCell align="right">{n.anomalies?.length || 0}</TableCell>
                    <TableCell>{worst}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default NodeTable;

